import fetcher, { STATUS_OK } from "../../libs/fetcher";

type IIndexAssetsTypes = {
    package_id: number;
    table: 'assets_its';
}

export const indexAssetsTypes = async ({ package_id, table }: IIndexAssetsTypes) => {
    const url = `/packages/${package_id}/${table}_types`;
    let response = { data: [], totalItems: 0, error: true };

    try {
        const fetchResponse = await fetcher({
            url,
            method: 'GET'
        });

        if (fetchResponse === undefined) {
            throw new Error('Request failed');
        }
        const { fetch } = fetchResponse;
        
        // console.log("🚀 ~ file: assets_types.ts:39 ~ indexAssetsTypes ~ fetch:", fetch)

        if (typeof fetch === 'string') {
            throw "Error al recibir la respuesta";
        } else if (fetch instanceof Object) {
            if ('status' in fetch && fetch.status === STATUS_OK) {
                const responseData = 'data' in fetch ? fetch.data : null;
                if (Array.isArray(responseData.data)) {
                    response.data = responseData.data;
                    response.error = false;
                    response.totalItems = responseData.totalItems;
                }
            }
        }

        return response;
    } catch (error) {
        return response;
    }
}